<template>
  <nav class="navbar">

    <div class="left">
      <router-link to="/" class="logo">RAPTORIS</router-link>

      <!-- desktop -->
      <div class="nav-links desktop">
        <router-link to="/nosotros">Nosotros</router-link>
        <router-link to="/servicios">Servicios</router-link>
        <router-link to="/contacto">Contacto</router-link>
      </div>
    </div>

    <!-- botón móvil -->
    <button class="menu-btn" @click="toggleMenu">
      ☰
    </button>

    <!-- menú móvil -->
    <div class="mobile-menu" :class="{ active: menuOpen }">
      <router-link @click="closeMenu" to="/nosotros">Nosotros</router-link>
      <router-link @click="closeMenu" to="/servicios">Servicios</router-link>
      <router-link @click="closeMenu" to="/contacto">Contacto</router-link>
    </div>

  </nav>
</template>

<script>
export default {
  name: "NavbarComponent",

  data() {
    return {
      menuOpen: false
    }
  },

  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>

/* NAVBAR */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1rem 2rem;
  background: linear-gradient(135deg, #06120d, #012719);
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 25px rgba(0,0,0,.2);

  position: relative;
  z-index: 1000;
}

/* LEFT SIDE */
.left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

/* LOGO */
.logo {
  color: white;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 2px;
}

/* DESKTOP LINKS */
.nav-links {
  display: flex;
  gap: 1.8rem;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  position: relative;
}

.nav-links a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;

  width: 0;
  height: 2px;
  background: white;
  transition: .3s;
}

.nav-links a:hover::after {
  width: 100%;
}

/* HAMBURGER */
.menu-btn {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
}

/* MOBILE MENU */
.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;

  width: 100%;
  background: #012719;

  display: flex;
  flex-direction: column;

  max-height: 0;
  overflow: hidden;
  transition: .3s ease;
}

.mobile-menu.active {
  max-height: 300px;
}

.mobile-menu a {
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-top: 1px solid rgba(255,255,255,.08);
}

/* TABLET + PHONE */
@media (max-width: 768px) {

  .desktop {
    display: none;
  }

  .menu-btn {
    display: block;
  }

  .logo {
    font-size: 1.25rem;
  }

  .navbar {
    padding: 1rem;
  }
}

</style>